var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderIcon = function SvgHeaderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.48 57.07"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#28c07f}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    fill: "#f5b90f",
    d: "M9.21 41.65c-2.14 2-3.87 3.33-4.12 3.08s1.06-2 3.07-4.12C3.51 40.54 0 40.23 0 39.85s3.52-.68 8.16-.75C6.15 37 4.84 35.23 5.09 35s2 1.06 4.12 3.07c.06-4.65.38-8.16.75-8.16s.69 3.52.76 8.16c2.13-2 3.87-3.32 4.12-3.07s-1.07 2-3.08 4.12c4.65.07 8.17.38 8.17.75s-3.52.69-8.17.76c2 2.14 3.32 3.87 3.08 4.12s-2-1.06-4.12-3.08c-.07 4.65-.38 8.17-.76 8.17s-.69-3.54-.75-8.19",
    "data-name": "Union 9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    cx: 27.85,
    cy: 54.39,
    fill: "#222",
    "data-name": "Ellipse 27",
    opacity: 0.15,
    rx: 21.69,
    ry: 2.68,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    d: "M50.82 8.17s0 12-3.83 16.07-11.48 6.7-14 4.69-4.46-7.37-1.27-11.38 8.93-5.36 12.76-6a12.74 12.74 0 0 0 6.34-3.38",
    className: "cls-3",
    "data-name": "Path 108"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    d: "M3.6 16.88s7-4 12.13-3.35 8.93 3.35 10.2 8-1.44 7.44-4.46 8.7c-3.19 1.34-7 0-9.57-5.35s-8.3-8-8.3-8",
    className: "cls-3",
    "data-name": "Path 109"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    fill: "#0f9b7b",
    d: "M30.4 53.05s-1.28 2.68-4.47 0c0 0 1.28-9.38 1.28-12.06a16.45 16.45 0 0 0-.64-7.37c-1.27-3.34-7-8.7-8.29-10s-3.83-3.35-2.55-3.35 4.46 1.34 7.65 4.69 5.74 6.7 5.74 6.7 3.19-6.7 5.1-8.71 7-8 8.94-6.7-3.19 4-4.47 5.36-7 10-7.66 12.72-.63 18.72-.63 18.72",
    "data-name": "Path 110"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    fill: "#f29230",
    d: "M28.5 8.82c-1.6 1.51-2.91 2.5-3.1 2.31s.8-1.49 2.31-3.13c-3.49 0-6.12-.29-6.12-.57s2.64-.51 6.12-.56C26.2 5.31 25.22 4 25.4 3.82s1.5.79 3.09 2.3c.05-3.48.29-6.12.57-6.12s.52 2.64.56 6.12c1.6-1.51 2.91-2.49 3.1-2.3s-.8 1.49-2.31 3.09c3.49 0 6.12.28 6.12.56S33.89 8 30.41 8c1.51 1.6 2.49 2.9 2.31 3.09s-1.5-.8-3.09-2.31c-.05 3.49-.29 6.13-.57 6.13s-.52-2.61-.56-6.09",
    "data-name": "Union 7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    fill: "#f2b878",
    d: "M43.44 38.72c-1.6 1.5-2.9 2.49-3.09 2.3s.8-1.49 2.31-3.09c-3.49 0-6.13-.28-6.13-.57s2.64-.51 6.13-.56c-1.51-1.6-2.5-2.9-2.31-3.09s1.49.8 3.09 2.3c.05-3.48.28-6.12.57-6.12s.51 2.64.56 6.12c1.6-1.51 2.91-2.49 3.09-2.3s-.8 1.49-2.3 3.09c3.48.05 6.12.28 6.12.56s-2.64.52-6.12.57c1.51 1.6 2.49 2.9 2.3 3.09s-1.49-.8-3.09-2.3c0 3.48-.28 6.12-.56 6.12s-.52-2.64-.57-6.12",
    "data-name": "Union 10"
  }))))));
};
export default SvgHeaderIcon;